import { useEffect } from 'react'
import { Outlet } from 'react-router'
import { MarketingNav } from './MarketingNav'
import { MarketingFooter } from './MarketingFooter'
import { writeShell } from './shell'
import styles from './PublicLayout.module.css'

/**
 * Layout for the public marketing and discovery surface (`/`, `/how-it-works`,
 * `/compete`, `/orgs`, `/universities`, `/news`, `/privacy`, `/terms`).
 *
 * Split out of AppLayout rather than adding another branch to it: AppLayout was
 * already keying four behaviours off a single `pathname === '/'` boolean, and
 * the two layouts genuinely want different chrome. Discovery pages still read
 * the auth store (for MyOrgsSection and TrustScoreChip) — that is a global
 * Zustand store initialised in main.tsx, not a provider, so it works here
 * without NotificationProvider.
 */
export function PublicLayout() {
  // The marketing counterpart to AppLayout's record: a visitor on the marketing
  // site who follows "Compete" stays on marketing chrome.
  useEffect(() => {
    writeShell('public')
  }, [])

  return (
    <>
      <div className="bgGlow" />
      <div className={styles.layout} data-shell="public">
        <MarketingNav />
        <main className={styles.content}>
          <Outlet />
        </main>
        <MarketingFooter />
      </div>
    </>
  )
}
